module.exports = [{
      plugin: require('/Users/brian/Projects/aridental/ari-dental-viewer/node_modules/gatsby-plugin-web-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"google":{"families":["Nunito","Open Sans"]}},
    },{
      plugin: require('/Users/brian/Projects/aridental/ari-dental-viewer/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
